import { render } from "./EditPet.vue?vue&type=template&id=637f5180&scoped=true"
import script from "./EditPet.vue?vue&type=script&lang=js"
export * from "./EditPet.vue?vue&type=script&lang=js"

import "./EditPet.vue?vue&type=style&index=0&id=637f5180&scoped=true&lang=css"

import exportComponent from "/Users/ergishoxha/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637f5180"]])

export default __exports__